
<div>
    <label class="amplify-input-label" for="localPhoneNumberField">
        {{ this.amplifyService.i18n().get(this._label) }}
        <span *ngIf="_required">*</span>
    </label>
    <div class="amplify-input-group">
        <div class="amplify-input-group-item">
            <select 
            #countryCodeField
            name="countryCode"
            class="amplify-select-phone-country"
            [(ngModel)]="_country_code"
            (change)="setCountryCode($event.target.value)"
            data-test="dial-code-select"
            >
            <option *ngFor="let country of _countries"
                value={{country.value}}>
                {{country.label}}
            </option>
            </select>
        </div>
        <div class="amplify-input-group-item">
            <input
                #localPhoneNumberField
                class="amplify-form-input"
                placeholder="{{ this.amplifyService.i18n().get(this.getPlaceholder()) }}"
                name="local_phone_number"
                type="tel"
                (keyup)="setLocalPhoneNumber($event.target.value)"
                data-test="phone-number-input"
            />
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./node_modules/aws-amplify-angular/dist/src/components/authenticator/phone-field-component/phone-field.component.core.d.ts.PhoneFieldComponentCore.html